var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiCardActionArea from '@material-ui/core/CardActionArea';
/**
 * Kareo wrapped component of the Material-UI CardActionArea. The prop API has been limited to props defined in CardActionAreaProps.
 *
 * Material-UI CardActionArea: [Docs](https://v4.mui.com/components/cards/), [API](https://v4.mui.com/api/card-action-area/)
 *
 * @storybook: [Card](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-card--card-example)
 */
var CardActionArea = React.forwardRef(function (props, ref) {
    return React.createElement(MuiCardActionArea, __assign({}, props, { ref: ref, disabled: true }));
});
CardActionArea.defaultProps = {};
CardActionArea.displayName = 'KareoCardActionArea';
export default CardActionArea;
